import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import {
  AuthCheckActivationRequestBody,
  AuthCheckActivationResponse,
} from "./types";

export class AuthCheckActivationAPI extends BaseAPI<
  AuthCheckActivationRequestBody,
  AuthCheckActivationResponse
> {
  protected route = ApiRoutes.auth.check_activation;
  protected method = RequestMethod.POST;
}
